import { useSelector } from 'react-redux';

import { offerDataSelector } from '../../selectors/offerData/offerDataSelector';
import { IOfferData } from '../../types/offerData';

export function useOfferDataSelector(): IOfferData {
  return useSelector(offerDataSelector);
}
